<template>
  <div class='streamer-panel'>
    <h1>{{solverNames[first]}}</h1>
    <h1>{{solverNames[(first+1)%2]}}</h1>
    <v-container style='text-align: left'>
      <v-row @click='deleteTime(0)'>
        <v-col cols='1' :class='["statistic", mode]'>{{statistic[0]}}</v-col>
        <v-col cols='2'>{{solverNames[first]}}</v-col>
        <v-col cols='1' v-for='(time, i) in showTimes' :key='i' :class='{winner: showWinner[i] === 0, loser: showWinner[i] === 1, [mode]: true}'>
          {{displayTime(time[0])}}
        </v-col>
      </v-row>
      
      <v-row @click='deleteTime(1)'>
        <v-col cols='1' :class='["statistic", mode]'>{{statistic[1]}}</v-col>
        <v-col cols='2'>{{solverNames[(first+1)%2]}}</v-col>
        <v-col cols='1' v-for='(time, i) in showTimes' :key='i' :class='{winner: showWinner[i] === 1, loser: showWinner[i] === 0, [mode]: true}'>
          {{displayTime(time[1])}}
        </v-col>
      </v-row>
    </v-container>
    <v-text-field v-model='currTime1' @keyup.enter='updateTime(0)'></v-text-field>
    <v-text-field v-model='currTime2' @keyup.enter='updateTime(1)'></v-text-field>
    <v-btn @click='swapFirst(true)'>SWAP NAMES</v-btn>
    <v-btn @click='swapTimes(true)'>SWAP TIMES</v-btn>
    <v-btn @click='routerBack'>BACK</v-btn>
  </div>
</template>

<script>
import utils from '@/modules/utils'
import io from 'socket.io-client'
import StreamerService from '@/services/TPC/StreamerService'

// TODO: import names from WCA?
// TODO: support more than 2 people in this list
// TODO: support solver 1 completing 3 solves while solver 2 is still on first solve

export default {
  name: 'streamer-panel',
  data () {
    return {
      solverNames: ['', ''],
      solverWca: ['', ''],
      times: [],
      currTime1: '',
      currTime2: '',
      first: 0,

      mode: 'score',
    }
  },
  methods: {
    async swapFirst (original) {
      if (original) {
        await StreamerService.swapSolvers()
        return
      }
      this.first = this.first === 0 ? 1 : 0
    },
    async swapTimes (original) {
      if (original) {
        await StreamerService.swapTimes()
        return
      }
      for (let i = 0; i < this.times.length; i++) {
        let tmp = this.times[i][0]
        this.$set(this.times[i], 0, this.times[i][1])
        this.$set(this.times[i], 1, tmp)
      }
    },
    routerBack () {
      this.$router.go(-1)
    },
    setTime (i, val) {
      if (this.times.length === 0 || (this.times[this.times.length - 1][0] && this.times[this.times.length - 1][1])) {
        this.times.push([])
      }
      val = parseFloat(val)
      this.$set(this.times[this.times.length - 1], i, val)
    },
    unsetTime (i) {
      if (this.times.length === 0) return
      this.$set(this.times[this.times.length - 1], i, undefined)
    },

    async updateTime (i) {
      let numStr = (i === 0) ? this.currTime1 : this.currTime2
      let val = 0
      if (numStr === 'd') {
        val = 'Infinity'
      } else {
        let n = parseInt(numStr)
        val += n % 10000
        n = Math.trunc(n/10000)
        val += n * 6000
        val *= 10
      }
      await StreamerService.addTime({
        time: val,
        pos: i,
      })
      this.currTime1 = ''
      this.currTime2 = ''
    },
    async deleteTime (i) {
      StreamerService.deleteTime({
        pos: i,
      })
    },

    displayTime (time) {
      let t = utils.displayTime(time)
      if (t === 'DNF') return t
      return t.substring(0, t.length - 1)
    }
  },
  computed: {
    winners () {
      return this.times.map(v => ((v[0] < v[1]) ? 0 : (v[1] < v[0] ? 1 : -1)))
    },
    statistic () {
      if (this.mode === "score") {
        if (this.winners.length === 0) return [0, 0]
        return this.winners.reduce((acc, v) => {
          if (v === 0 || v === 1) acc[v]++
          return acc
        }, [0, 0])
      } else {
        let solverTimes = [[],[]]
        this.times.forEach((v) => {
          // TODO: check if time is missing
          if (v[0]) solverTimes[0].push(v[0])
          if (v[1]) solverTimes[1].push(v[1])
        });
        if (this.mode === "bpa") {
          return solverTimes.map((times) => {
            if (times.length != 4) return ""
            times.sort((a, b) => a - b)
            let bpa = Math.round(times.slice(0, times.length - 1).reduce((acc, v) => acc + v) / (times.length -1))
            return this.displayTime(bpa)
          })
        }

      }
      return ["n/a", "n/a"]
    },
    showTimes () {
      return this.times.slice(Math.max(0, this.times.length - 5))
    },
    showWinner () {
      return this.showTimes.map(v => ((v[0] < v[1]) ? 0 : (v[1] < v[0] ? 1 : -1)))
    },
  },
  async created () {
    this.$store.state.socket = io.connect(this.$backendHost, {
      query: {
        connectionType: 'stream',
      }
    })

    this.$store.state.socket.on('ehlo', async () => {
      if (this.$route.query.solverNames && this.$route.query.solverNames.length > 0) {
        for (let i = 0; i < this.$route.query.solverNames.length; i++) {
          await StreamerService.addSolver({
            pos: i,
            name: this.$route.query.solverNames[i],
            wcaID: this.$route.query.solverWca[i] || ''
          })
        }
      }
    })

    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode    
    }

    this.$store.state.socket.on('solver', (data) => {
      // reset the times first
      this.first = 0
      this.times = []
      this.solverNames[data.pos] = data.name
      this.solverWca[data.pos] = data.wcaID
    })
    this.$store.state.socket.on('swap', () => {
      this.swapFirst()
    })
    this.$store.state.socket.on('swaptimes', () => {
      this.swapTimes()
    })
    this.$store.state.socket.on('addTime', (data) => {
      this.setTime(data.pos, data.time)
    })
    this.$store.state.socket.on('deleteTime', (data) => {
      this.unsetTime(data.pos)
    })
  },
}
</script>

<style scoped>
h1 {
  text-align: left;
  font-size: 100px;
  background: #2F40DD;
  color: white;
  font-family: 'Roboto', sans-serif;
}
.container {
  margin-left: unset;
}
.col {
  font-weight: 600;
  font-size: 30px;
}
.col-1 {
  flex: 0 0 135px;
  max-width: 135px;
}
.col-2 {
  max-width: 350px;
  flex: 0 0 350px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
div {
  color: black
}
.statistic.score{
  background: rgba(255, 123, 0, 0.7);
  text-align: right;
  padding-right: 35px;
}
.winner.score {
  background: rgba(0, 255, 0, 0.5)
}
.loser.score {
  background: rgba(255, 0, 0, 0.5)
}

::v-deep input {
  font-size: 10vh;
  max-height: unset !important;
  background: lightgreen;
}

svg {
  width: 100%;
}
</style>
